// ============================================================
// Datei: src/components/Footer.jsx
// Purpose: Globale Footer-Leiste mit Impressum + Datenschutz
// ============================================================

import React from "react";
import { Link } from "react-router-dom";
import "../styles/footer.css";


const Footer = () => {
    return (
        <footer className="footer-container">
            <div className="footer-links">
                <Link to="/impressum" className="footer-link">Impressum</Link>
                <Link to="/datenschutz" className="footer-link">Datenschutz</Link>
            </div>

            <div className="footer-copy">
                © {new Date().getFullYear()} Festival des Arcs – FestivalPortal
            </div>
        </footer>
    );
};

export default Footer;
